module.exports = __webpack_public_path__ + "static/media/fileIcon.69e13991.png";